// extracted by mini-css-extract-plugin
module.exports = {"section":"section_section__3nKza","name":"section_name__ahaFQ","post":"section_post__3jkjL","title":"section_title__12oFt","text":"section_text__11367"};